// Lightweight cookie helper used for retrieving XSRF tokens at runtime.
const readCookie = (name: string) => {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');

  for (const rawCookie of cookies) {
    let cookie = rawCookie;

    while (cookie.startsWith(' ')) {
      cookie = cookie.substring(1, cookie.length);
    }

    if (cookie.startsWith(nameEQ)) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
};

const cookieManager = {
  readXsrfToken: () => readCookie('XSRF-TOKEN'),
};

export default cookieManager;
